import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { getSeoDescription } from 'features/page-model/ducks/get-model';
import { seoDescriptionStyle } from './style';

export const SeoDescriptionSection: FC = () => {
  const description = useSelector(getSeoDescription);
  return (
    <div
      data-qa-seo-text=""
      className={seoDescriptionStyle}
      dangerouslySetInnerHTML={{ __html: description ?? '' }}
    />
  );
};
